export default __webpack_public_path__ + "static/media/txt_entrance_08.bc717ac1.svg";